import { CtDocument } from '@ps-gui/claims-terminal-shared';
import { entries } from '@ps-gui/shared-utils';
import { TableKey } from '../models/extraction-models/extraction-models';
import {
  BuildSimpleExtractedTableRowDto,
  BuildSimpleExtractionResultDto,
} from '../models/build-simple-model';
import { TableData } from '../table-overlay/table-overlay';
import { extractTableLinesFromBuildSimpleRows } from './build-simple-rows-to-table-lines';
import { mergeRowsTooCloseToEachOther } from './build-simple-close-row-merging';
import { getRowPage } from './build-simple-row-access';
import { signal } from '@angular/core';

export interface BuildSimpleTable {
  tableKey: TableKey;
  overlayData: TableData;
  originalRows: BuildSimpleExtractedTableRowDto[];
}

export const getBuildSimpleExtractedTables = (
  document: CtDocument,
  buildSimpleTableRowDtosByKey: BuildSimpleExtractionResultDto['groups'],
): BuildSimpleTable[] =>
  entries(buildSimpleTableRowDtosByKey).flatMap(([tableKey, rows]) =>
    getTablesForDocument(document, rows).map((table) => ({
      ...table,
      tableKey,
    })),
  );

const getTablesForDocument = (
  document: CtDocument,
  rows: BuildSimpleExtractedTableRowDto[],
): Omit<BuildSimpleTable, 'tableKey'>[] => {
  const cleanedRows = mergeRowsTooCloseToEachOther(rows);
  const rowsByPage = Object.groupBy(
    cleanedRows.filter((row) => getRowPage(row) !== undefined),
    (row) => getRowPage(row)!,
  );

  // Build simple page numbers are not guaranteed to be within this document
  return entries(rowsByPage)
    .filter(([oneBasedPage]) => document.pages[oneBasedPage - 1] !== undefined)
    .map(([oneBasedPage, rows]) => {
      const pageId = document.pages[oneBasedPage - 1].id;

      const { extractedLines, columnHeaders } = extractTableLinesFromBuildSimpleRows(rows);

      const tableOverlayId = `${document.id}_${oneBasedPage}`;

      return {
        overlayData: {
          // TODO: Set correct key
          tableModelKey: 'forderungen',
          pageId: pageId,
          confirmed: signal(true),
          layoutDefined: signal(true),
          id: tableOverlayId,
          lines: {
            vertical: extractedLines.vertical,
            horizontal: extractedLines.horizontal,
          },
          columnHeaders: signal(columnHeaders),
        },
        originalRows: rows,
      };
    });
};
